module.exports = __webpack_public_path__ + "static/media/wge2.png.1091885d.jpg";